import "./Footer.css";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaShieldAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer-corporate">
      <div className="footer-container">
        {/* Colonne 1 : Entreprise & Agrément */}
        <div className="footer-col brand-col">
          <Link to="/" className="footer-logo">
            <img src="/logo.png" alt="Logo WSPS - Wourou Sécurité" className="footer-logo-img" />
          </Link>
          <p className="footer-tagline">
            Société de sécurité privée d’excellence en Île-de-France. Spécialiste de la protection cynophile,
            de la sécurité incendie et de la surveillance de sites sensibles.
          </p>
          <div className="footer-cnaps-badge">
            <FaShieldAlt className="cnaps-icon" />
            <div>
              <span>Autorisation CNAPS</span>
              <strong>AUT-078-2124-07-22-20250989623</strong>
            </div>
          </div>
        </div>

        {/* Colonne 2 : Prestations */}
        <div className="footer-col">
          <h4 className="footer-heading">Nos Prestations</h4>
          <ul className="footer-nav">
            <li><a href="#services">Sécurité Cynophile (Maître-Chien)</a></li>
            <li><a href="#services">Sécurité Incendie (SSIAP 1/2/3)</a></li>
            <li><a href="#services">Surveillance Statique (ADS)</a></li>
            <li><a href="#services">Sécurité Mobile & Rondes 24/7</a></li>
            <li><a href="#services">Sécurité Événementielle</a></li>
          </ul>
        </div>

        {/* Colonne 3 : Secteurs & Méthode */}
        <div className="footer-col">
          <h4 className="footer-heading">Zones d'Intervention</h4>
          <ul className="footer-nav">
            <li><a href="#domaines">Chantiers BTP & Infrastructures</a></li>
            <li><a href="#domaines">Entrepôts & Plateformes Logistiques</a></li>
            <li><a href="#domaines">Grande Distribution & Magasins</a></li>
            <li><a href="#domaines">Immeubles, Résidences & Tertiaire</a></li>
            <li><a href="#process">Notre Démarche en 3 Étapes</a></li>
          </ul>
        </div>

        {/* Colonne 4 : Contact Direct */}
        <div className="footer-col">
          <h4 className="footer-heading">Astreinte & Devis</h4>
          <div className="footer-contacts">
            <a href="tel:+33602615612" className="footer-contact-item">
              <FaPhoneAlt className="f-icon" />
              <div>
                <span className="fc-label">Permanence 24/7</span>
                <strong>+33 6 02 61 56 12</strong>
              </div>
            </a>

            <a href="mailto:contact@wsps.fr" className="footer-contact-item">
              <FaEnvelope className="f-icon" />
              <div>
                <span className="fc-label">Demande par e-mail</span>
                <strong>contact@wsps.fr</strong>
              </div>
            </a>

            <div className="footer-contact-item">
              <FaMapMarkerAlt className="f-icon" />
              <div>
                <span className="fc-label">Siège social</span>
                <span>78180 Montigny-le-Bretonneux</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Barre des mentions légales réglementaires */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="csi-warning">
            <strong>Article L 612-14 du Code de la Sécurité Intérieure :</strong> L'autorisation d'exercice ne confère
            aucune prérogative de puissance publique à l'entreprise ou aux personnes qui en bénéficient.
          </p>

          <div className="footer-legal-grid">
            <span>Raison sociale : WSPS – WOUROU SURVEILLANCE PROTECTION SÉCURITÉ</span>
            <span>SIRET : 945 173 516 00010</span>
            <span>RCS : Versailles B 945 173 516</span>
            <span>TVA : FR70 945 173 516</span>
            <span>Capital : 1 000 €</span>
          </div>

          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} WSPS Sécurité Privée. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
